import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type CityProps = {
  span?: number;
} & TextInputProps;

export const City: React.FC<CityProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.city`}
        label={t(`${TRANS_KEY}.CITY_LABEL`)}
        required
        {...props}
      />
    </Grid.Col>
  );
};
